import type { Theme } from '@mui/material';

export const styles = {
  myFollowUpPage: {
    '& .PageFrame-children': {
      pl: 0,
      pr: 0,
      pt: 0,
      pb: 0,
    },
  },

  divider: (theme: Theme) => ({
    borderColor: theme.colors.neutral[100],
    borderBottomWidth: '2px',
    marginTop: '-2px',
  }),
};
